import styled from 'styled-components';

const StyledInputWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: transparent;

  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
`;

export default StyledInputWrapper;
